import * as React from "react";

const UserIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <g clip-path="url(#clip0_1626_1099)">
  <path d="M13.8813 12.064C11.5887 11.5347 9.454 11.0707 10.488 9.11867C13.634 3.17733 11.322 0 8 0C4.612 0 2.35667 3.29933 5.512 9.11867C6.57733 11.082 4.362 11.546 2.11867 12.064C0.132667 12.5227 0 13.4927 0 15.1727L0.00333333 16H1.33333C1.33333 13.9107 1.25 13.6333 2.55867 13.3313C4.45933 12.8933 6.254 12.4793 6.90867 11.0273C7.148 10.4973 7.30333 9.62533 6.68333 8.484C5.31133 5.95133 4.96467 3.758 5.73467 2.46667C6.63733 0.95 9.352 0.957333 10.246 2.444C11.0127 3.718 10.672 5.92333 9.31067 8.49467C8.704 9.64067 8.86333 10.51 9.104 11.0373C9.764 12.482 11.5753 12.9 13.4933 13.3427C14.746 13.6333 14.6667 13.9307 14.6667 16H15.9967L16 15.1727C16 13.4927 15.8673 12.5227 13.8813 12.064Z" fill="black"/>
  </g>
  <defs>
  <clipPath id="clip0_1626_1099">
  <rect width="16" height="16" fill="white"/>
  </clipPath>
  </defs>
  </svg>
)
export default UserIcon;
